<script lang="ts">
    import { MFE_MODULE_NAMES } from '$src/lib/services/blocks/constants';
    import PractiseBlock from './PractiseBlock.svelte';
    import PractiseLayout from './PractiseLayout.svelte';
    import PageComposer from '$src/lib/components/PageBuilder/PageComposer.svelte';

    export let data;
    $: ({ pageData, practiseSlotBlocks, isLoggedIn, debugMode: debug, inGameTranslations } = data);
</script>

{#if !isLoggedIn}
    {#if pageData}
        <PageComposer page={pageData} {debug} />
    {/if}
{:else if practiseSlotBlocks}
    <PractiseLayout {inGameTranslations}>
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.IN_GAME_ADVENTURE_WIDGET]}
            {debug}
            slot="in-game-adventure-widget"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.IN_GAME_WALLET_BALANCE]}
            {debug}
            slot="wallet-balance-in-game"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.IN_GAME_RIDABODO_WIDGET]}
            {debug}
            slot="in-game-ridabodo-widget"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.IN_GAME_AVATAR_WIDGET]}
            {debug}
            slot="in-game-profile-icon"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.IN_GAME_RECENT_VALUABLE]}
            {debug}
            slot="in-game-recent-valuable"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.LIKES_COUNTER]}
            {debug}
            slot="likes-counter"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.LAUNCHER]}
            {debug}
            slot="launcher"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.SESSION_CONFIGURATION]}
            {debug}
            slot="session-configuration"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.RIDABODO_INVITE_POP_UP]}
            {debug}
            slot="ridabodo-invite-pop-up"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.GAME_INFO_BAR]}
            {debug}
            slot="game-info-bar"
        />
        <PractiseBlock
            data={practiseSlotBlocks[MFE_MODULE_NAMES.GAMEPLAY_RG_BAR]}
            {debug}
            slot="gameplay-rg-bar"
        />
        <PractiseBlock data={practiseSlotBlocks[MFE_MODULE_NAMES.RG_BAR]} {debug} slot="rg-bar" />
    </PractiseLayout>
{/if}
